// Native
import Apex from 'react-apexcharts'

// Components
import {Flex, Spinner, useColorMode } from '@chakra-ui/react'

// Config
import { Moment, Mask } from 'config'

// Hooks
import { useReport } from 'hooks'

export default function TransactionsRealXWithdrawsMonthlyGrowthChart({ period, ...props }){

    const { colorMode } = useColorMode()
    const report = useReport('withdraws_x_transactions_real_monthly_growth', period)

    const dates = report.data?.data?.transactions?.map(item => item.date)

    const series = [
        {
            name: 'Entrada financeira real (R$)',
            data: report.data?.data?.transactions?.map(item => Mask.price(item.monthly_growth))
        },{
            name: 'Saques aprovados (R$)',
            data: report.data?.data?.withdraws?.map(item => Mask.price(item.monthly_growth))
        }
    ]

    const options = {
        theme: { 
            mode: colorMode,
            palette: 'palette2'
        },
        title: {
            text: 'Ganhos Reais x Saques Aprovados (Mensal)',
            align: 'center'
        },
        subtitle: {
            text: `Com dados de ${Moment(report.data?.metadata?.starts).format('LL')} até ${Moment(report.data?.metadata?.ends).format('LL')} | Última atualização ${Moment(report.data?.metadata?.updated_at).calendar()}`,
            align: 'center'
        },
        chart: { 
            height: 350, 
            type: 'area', 
            background: 'transparent',
            locales: [require('apexcharts/dist/locales/pt.json')],
            defaultLocale: 'pt',
            zoom: { 
                enabled: true 
            }, 
            animations: { 
                enabled: true, 
                easing: 'easeinout', 
                animateGradually: {
                    enabled: true,
                    delay: 150 
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            } 
        },
        dataLabels: { 
            enabled: false 
        },
        stroke: { 
            curve: 'smooth'
        },
        grid: { 
            show: false 
        },
        xaxis: { 
            type: 'datetime', 
            categories: dates 
        },
        yaxis: {
            show: false
        },
        tooltip: { 
            x: { 
                format: 'MM/yy' 
            }, 
        }
    }

    // Loading state
    if(report.isLoading) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    // Chart
    return <Apex options={options} series={series} type="area" height={350} />
}